module.exports = __webpack_public_path__ + "img/f-thermometer-img7-1.14208a96.jpg";